export const GetAlertSystemList = "/Market/GetAlertSystemList";
export const GetAlertUserList = "/Alert/GetAlertUserList";

export const AlertRead = "/Alert/AlertRead";
